import { notification } from 'antd';
import { FormattedMessage } from 'react-intl';

const successNotification = (message) => {
  notification.success({
    message: message,
  });
};
const Notification = (type, message) => {
  notification[type]({
    message: message,
  })
}

const errorNotification = (message) => {
  notification.error({
    message: message,
  });
};

const warningNotification = (message) => {
  notification.warning({
    message: message,
  });
};



export { successNotification, errorNotification, warningNotification, Notification };
